import axios from 'axios'
import Cookies from 'js-cookie'
import * as types from '../mutation-types'

// state
export const state = {
  user: null,
  servicios: [],
  cuentas: [],
  token: Cookies.get('token')
}

// getters
export const getters = {
  user: state => state.user,
  token: state => state.token,
  servicios: state => state.servicios,
  cuentas: state => state.cuentas,
  cuenta_corriente: state => {
    //const array = state.cuentas.reduce(({a: {cuenta_corriente:cc}}, b) => cc.concat(b.cuenta_corriente) )
    
    return state.cuentas.reduce(
      //  First argument is our reducer/callback function: 
      (accumulator, account) => {
          return accumulator.concat(account.cuenta_corriente)
      },
      //  The 2nd argument (optional) is the initial value:
      []
    )
  },
  check: state => state.user !== null
}

// mutations
export const mutations = {
  [types.SAVE_TOKEN] (state, { token, remember }) {
    state.token = token
    Cookies.set('token', token, { expires: remember ? 365 : null })
  },

  [types.FETCH_USER_SUCCESS] (state, { user }) {
    state.user = user
  },

  [types.FETCH_SERVICIOS] (state, data) {
    var array = [];
    for( var key in data ) {
        array.push(data[key])
    }
    state.servicios = array
  },

  [types.FETCH_CUENTAS] (state, data) {
    state.cuentas = data
  },

  [types.FETCH_USER_FAILURE] (state) {
    state.token = null
    Cookies.remove('token')
  },

  [types.LOGOUT] (state) {
    state.user = null
    state.token = null
    state.cuentas = []
    state.servicios = []
    state.cuenta_corriente = []
    Cookies.remove('token')
  },

  [types.UPDATE_USER] (state, { user }) {
    state.user = user
  }
}

// actions
export const actions = {
  saveToken ({ commit }, payload) {
    commit(types.SAVE_TOKEN, payload)
  },

  async fetchUser ({ commit }) {
    try {
      // Colocar las consultas si esta logueado
      const { data: { data:persona } } = await axios.get('/users/me')
      commit(types.FETCH_USER_SUCCESS, { user: persona })

      // Solicitar cuentas generar Alias para nombre de constantes (CuentaData)
      const { data: { data:CuentaData } } = await axios.get('/cuentas/personas/' + persona.id)

      // Obtener cuenta corriente de cada cuenta
      CuentaData.forEach(async (cuenta, key) => {
        const { data: { data:CuentaCorrienteData } } = await axios.get('/transac/cuenta-corriente/' + cuenta.id)
        CuentaData[key].cuenta_corriente = CuentaCorrienteData
        if(CuentaData.length == (key + 1)){
          commit(types.FETCH_CUENTAS, CuentaData )
        }
      })
      
      // Solicitar Servicios
      const { data: { data:servicios } } = await axios.get('/servicios/by-persona/' + persona.id)
      commit(types.FETCH_SERVICIOS, servicios )
    } catch (e) {
      commit(types.FETCH_USER_FAILURE)
    }
  },

  async fetchCuentas ({ commit }, id) {
    try {
      const { data: { data } } = await axios.get('/cuentas/personas/' + id)
      commit(types.FETCH_CUENTAS, data )
      return Promise.resolve(data)
    } catch (e) {
      commit(types.FETCH_USER_FAILURE)
    }
  },

  async fetchServicios ({ commit }, id) {
    try {
      const { data: { data } } = await axios.get('/servicios/by-persona/' + id)
      commit(types.FETCH_SERVICIOS, data )
      return Promise.resolve(data)
    } catch (e) {
      commit(types.FETCH_USER_FAILURE)
    }
  },

  async fetchCuentaCorriente ({ commit }, id) {
    try {
      const { data: { data } } = await axios.get('/transac/cuenta-corriente/' + id)
      const cuentas = state.cuentas
      cuentas.forEach((cuenta, index) => {
        if(cuenta.id == id){
          cuenta.cuenta_corriente = data
          cuentas[index] = cuenta
        }
      })
      commit(types.FETCH_CUENTAS, cuentas )
    } catch (e) {
      commit(types.FETCH_USER_FAILURE)
    }
  },

  updateUser ({ commit }, payload) {
    commit(types.UPDATE_USER, payload)
  },

  async logout ({ commit }) {
    commit(types.LOGOUT)
  },

  async fetchOauthUrl (ctx, { provider }) {
    const { data } = await axios.post(`/api/oauth/${provider}`)

    return data.url
  }
}
